import { Space, Typography } from 'antd'
import { FDCNotificationEvent } from 'shared'

const FDCNotificationDetails: React.FC = () => {
  const usersAndRoles = 'Users, and Users of Roles' as const
  const alwaysReceiveFor = 'always receive notifications for' as const
  const regardless = '; regardless of the Concurrence Level' as const
  return (
    <Space direction="vertical">
      <Typography.Text>
        {usersAndRoles}, associated with Concurrence Groups {alwaysReceiveFor}{' '}
        {FDCNotificationEvent.Submitted.name} and{' '}
        {FDCNotificationEvent.ConcurrenceLevelRejected.name}
        {regardless}
      </Typography.Text>
      <Typography.Text>
        {usersAndRoles}, associated with Approval Groups {alwaysReceiveFor}{' '}
        {FDCNotificationEvent.PendingApprovals.name}
        {regardless}
      </Typography.Text>
    </Space>
  )
}

export default FDCNotificationDetails
